<template lang="pug">
  .root
    the-heading(:caption="'Обратная связь'" :breadcrumbs="breadcrumbs")
    .container
      .main_block
        .globalCaptionStyles.localCaption Обратная связь
        .filter_block
          Keypress(:key-code="13" event="keyup" @pressed="pressEnter")
          .fields
            .item
              label ID
              .field_container
                WebiomedInput(v-model="filter.id" :value="filter.id || null")
            .item
              label Совершён c
              .field_container
                WebiomedDatepicker(v-model="filter.created_date__gt" :value="filter.created_date__gt || null")
            .item
              label Совершён по
              .field_container
                WebiomedDatepicker(v-model="filter.created_date__lt" :value="filter.created_date__lt || null")
            .item(id="longField")
              label Название МО
              .field_container
                WebiomedSearchField(
                  v-model="filter.hospital_name"
                  :value="filter.hospital_name"
                  :search_by="'hospital_name'"
                  :show="'hospital_name'"
                  :address="'webiomedmpi/requests/hospital-names/'"
                  :fieldAdd="'?hospital_name__icontains='"
                  :placeholder="'Введите название МО'"
                  :icons="'clinic-medical'",
                  :namespase="'BackReports'"
                  )
            .item
              label Статус отзыва
              .field_container
                WebiomedSelect(:options="options" :value="filter.status_correctness" v-model="filter.status_correctness")
          .buttons
            button.find(@click="find") Найти
            button.clear(@click="clear") Очистить фильтры
            //- v-icon(name="notes-medical sx")
            div(style="display: inline-block; margin-left: 5px") Количество записей:
            span(style="font-weight: bold") {{' ' +count}}
        page-grid(:cols="cols" ref="grid" :response="data" :nextState="nextState" :count="count")
</template>

<script>
import TheHeading from '@/components/parts/TheHeading'
import WebiomedInput from '@/components/fields/WebiomedInput'
import WebiomedDatepicker from '@/components/fields/WebiomedDatepicker'
import WebiomedSearchField from '@/components/fields/WebiomedSearchField'
import WebiomedSelect from '@/components/fields/WebiomedSelect'
import PageGrid from '../parts/PageGrid'
import pageGridMixin from '@/mixins/pageGridMixin'
import breadcrumbs from '@/data/breadcrumbs/Requests'
import cols from '@/data/cols/backReports'
import options from '@/data/options/gradeStatus'
import Icon from 'vue-awesome/components/Icon'

export default {
  components: {
    PageGrid,
    TheHeading,
    WebiomedInput,
    WebiomedDatepicker,
    WebiomedSearchField,
    WebiomedSelect,
    'v-icon': Icon,
    breadcrumbs,
    Keypress: () => import('vue-keypress')
  },
  mixins: [pageGridMixin],
  data () {
    return {
      address: 'webiomedmpi/requests/?fields=id,created_date,hospital_name,patient_id,use_case,created_by_region_name,result_correctness,recommendation_correctness,status_correctness_text',
      api: 'dhra/api/v2/',
      defaultParams: {
        result_correctness__isnull: false
      },
      breadcrumbs,
      cols,
      options,
      nextState: 'BackReportSummary'
    }
  },
  created () {
    if (this.$route.query) {
      for (let key in this.$route.query) {
        if (key !== 'created_by' && key !== 'status_correctness') {
          this.filter[key] = this.$route.query[key]
        }
      }
    }
    localStorage.removeItem('sParams')
  },
  methods: {
    setData (response) {
      this.data = response.map(item => {
        return {
          id: item.id,
          created_date: this.$moment(item.created_date).format('DD.MM.YYYY'),
          hospital: item.hospital_name,
          region: item.created_by_region_name,
          recommendation:
            item.result_correctness + ' / ' + item.recommendation_correctness,
          status: item.status_correctness_text
        }
      })
    }
  }
}
</script>

<style lang="sass" scoped>
@import "@/css/pageGridStyles.sass"
#longField
  grid-column: 1 / span 2

@media screen and (max-width: 1460px)
  #longField
    grid-column: 1
</style>
<style lang="sass">
.BackReports
  font-size: 15px
  height: 32px
</style>
